(function(){
  var root = document.querySelector('[data-vb-stage]');
  if(!root) return;
  if(root.dataset.vbInit) return;
  root.dataset.vbInit = '1';

  var card = root.querySelector('[data-vb-card]');
  var sheen = root.querySelector('[data-vb-sheen]');
  var hint = document.querySelector('[data-vb-hint]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var rotX = 0, rotY = 0;
  var dragging = false;
  var lastX = 0, lastY = 0;
  var velX = 0;
  var momentumFrame = null;
  var hasInteracted = false;

  function render(){
    card.style.transform = 'rotateX(' + rotX.toFixed(2) + 'deg) rotateY(' + rotY.toFixed(2) + 'deg)';
    sheen.style.backgroundPosition = (50 + (rotY/60)*60) + '% ' + (50 - (rotX/20)*40) + '%';
  }

  function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }

  function onPointerDown(e){
    dragging = true;
    hasInteracted = true;
    if(hint) hint.classList.add('vb3d-hidden');
    card.classList.add('vb3d-dragging');
    card.classList.remove('vb3d-settled');
    lastX = e.clientX; lastY = e.clientY;
    velX = 0;
    if (momentumFrame) cancelAnimationFrame(momentumFrame);
    try { card.setPointerCapture(e.pointerId); } catch(err){}
  }

  function onPointerMove(e){
    if(!dragging) return;
    var dx = e.clientX - lastX;
    var dy = e.clientY - lastY;
    lastX = e.clientX; lastY = e.clientY;
    rotY = clamp(rotY + dx * 0.4, -140, 140);
    rotX = clamp(rotX - dy * 0.3, -22, 22);
    velX = dx * 0.4;
    render();
  }

  function onPointerUp(e){
    if(!dragging) return;
    dragging = false;
    card.classList.remove('vb3d-dragging');
    try { card.releasePointerCapture(e.pointerId); } catch(err){}
    startMomentum();
  }

  function startMomentum(){
    function step(){
      velX *= 0.94;
      rotX *= 0.9;
      if (Math.abs(velX) < 0.02 && Math.abs(rotX) < 0.2){
        rotX = 0;
        card.classList.add('vb3d-settled');
        render();
        return;
      }
      rotY = clamp(rotY + velX, -140, 140);
      render();
      momentumFrame = requestAnimationFrame(step);
    }
    momentumFrame = requestAnimationFrame(step);
  }

  card.addEventListener('pointerdown', onPointerDown);
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);
  window.addEventListener('pointercancel', onPointerUp);

  card.addEventListener('keydown', function(e){
    var step = 12;
    if (e.key === 'ArrowLeft'){ rotY = clamp(rotY - step, -140, 140); render(); hasInteracted = true; if(hint) hint.classList.add('vb3d-hidden'); }
    if (e.key === 'ArrowRight'){ rotY = clamp(rotY + step, -140, 140); render(); hasInteracted = true; if(hint) hint.classList.add('vb3d-hidden'); }
    if (e.key === 'ArrowUp'){ rotX = clamp(rotX + step*0.6, -22, 22); render(); }
    if (e.key === 'ArrowDown'){ rotX = clamp(rotX - step*0.6, -22, 22); render(); }
  });

  if (!reduceMotion){
    setTimeout(function(){
      if (hasInteracted) return;
      var t0 = performance.now();
      function wiggle(now){
        var t = (now - t0) / 1000;
        if (t > 2.2 || hasInteracted){ render(); return; }
        rotY = Math.sin(t * 2.4) * 14;
        render();
        requestAnimationFrame(wiggle);
      }
      requestAnimationFrame(wiggle);
    }, 900);
  }

  render();
})();